import { BACKEND_BASE_URL } from "./backendBaseUrl";

export const OWNERSHIP_BASE_URL = BACKEND_BASE_URL + "/ownership";
export const CHANGE_OWNERSHIP = "/change";
